import React from 'react'
import SettingsForm from './SettingsForm';
import SettingsMain from './SettingsMain';
import SettingsNotification from './SettingsNotification';
import SettingsProfile from './SettingsProfile';
import SettingsSidebar from './SettingsSidebar';

const Settings = () => {
    return (
        <div className="_nft_settings_wrapper">
            <div className="_nft_settings_wrap">
                <div className="_nft_settings_container">
                    <SettingsSidebar/>
                    <div className="_nft_settings_main_wrap">
                        <SettingsMain/>
                        <SettingsProfile/>
                        <SettingsForm/>
                        <SettingsNotification/>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Settings;